if (!customElements.get('size-guide')) {
  customElements.define(
    'size-guide',
    class SizeGuide extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', this.onTabKeydown.bind(this));
        });

        this.highlight(this.dataset.selectedSize);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const size = this.sizeFromVariant(event.data?.variant);
            if (size) {
              this.dataset.selectedSize = size;
              this.highlight(size);
            }
          });
        }
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      sizeFromVariant(variant) {
        if (!variant) return '';
        const known = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
        const values = []
          .concat(variant.options || [])
          .concat([variant.option1, variant.option2, variant.option3])
          .filter(Boolean)
          .map((value) => String(value).trim().toUpperCase());

        return values.find((value) => known.includes(value)) || '';
      }

      highlight(size) {
        const needle = String(size || '').trim().toUpperCase();
        this.querySelectorAll('[data-size]').forEach((row) => {
          const match = needle !== '' && row.dataset.size.toUpperCase() === needle;
          row.classList.toggle('is-current', match);
          if (match) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        });
      }

      selectTab(tab) {
        const panelId = tab.getAttribute('aria-controls');

        this.tabs.forEach((item) => {
          const on = item === tab;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });

        tab.focus();
      }

      onTabKeydown(event) {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        const index = this.tabs.indexOf(event.currentTarget);
        let next = index;

        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;

        this.selectTab(this.tabs[next]);
      }
    }
  );
}
